import { implementCustomExpressions } from '../__generated/implementation.js';
import { FenixVariant } from '../__generated/model/index.js';
import { AVAILABLE_LEG_TYPES_RECTANGLE } from './top-rectangle.js';
export const topHalfCircleExpressions = implementCustomExpressions({
    TopHalfCircle: {
        $objectName: (self)=>self.fenixVariant === FenixVariant.Birch ? 'FENIX_HALVE_CIRKEL_HALF_CIRCLE' : 'HALVE_CIRKEL_HALF_CIRCLE',
        $availableLegTypes: ()=>AVAILABLE_LEG_TYPES_RECTANGLE
    }
});

//# sourceMappingURL=top-half-circle.js.map